import * as a from '@mitranim/js/all.mjs'
import * as c from './conf.mjs'
import * as ue from './util-err.mjs'

export function maybeLogErr(err) {
  if (shouldLogErr(err)) logErr(err)
}

export function logDebug(...val) {
  if (!a.vac(val)) return
  if (c.LOG_DEBUG) logWrite(console.log, c.SEVERITY_DEBUG, ...val)
}

export function logInfo(...val) {
  if (!a.vac(val)) return
  logWrite(console.log, c.SEVERITY_INFO, ...val)
}

export function logErr(...val) {
  if (!a.vac(val)) return
  if (!a.some(val, shouldLogErr)) return
  logWrite(console.error, c.SEVERITY_ERROR, ...val)
  ue.sentryCaptureException(...val)
}

function logWrite(write, severity, ...msgs) {
  a.reqFun(write)
  if (!a.vac(msgs)) return

  if (!c.DOM_AVAILABLE && c.LOG_TYPE === c.LOG_TYPE_JSON) {
    write(a.jsonEncode({
      severity: severity || logSeverity(msgs),
      message: listToLogMessage(msgs),
    }))
    return
  }

  if (severity) write(`[${severity}]`, ...msgs)
  else write(...msgs)
}

function logSeverity(vals) {
  return a.some(vals, isErr) ? c.SEVERITY_ERROR : c.SEVERITY_INFO
}

function listToLogMessage(vals) {
  if (vals.length === 0) return ``
  if (vals.length === 1) return toLogMessage(vals[0])
  return a.map(vals, toLogMessage).map(a.laxStr).filter(a.truthy).join(`\n`)
}

function toLogMessage(value) {
  // Error stack seems to include error message, at least in Node.
  if (isErr(value)) return value.stack
  return a.show(value)
}

function isErr(value) {
  return a.isInst(value, Error)
}

export function shouldLogErr(err) {
  if (!err) return false
  if (c.LOG_DEBUG) return true
  if (ue.isErrAbort(err)) return false

  const status = err.status || a.laxStruct(err.res).status

  // Don't report common network errors such as 401, 404, etc.
  // HTTP errors with code 0 may occur on disconnect, timeout, etc.
  if (status > 0 && status < 500) return false

  return true
}
